import { render, staticRenderFns } from "./EditLive.vue?vue&type=template&id=d6bcee90&scoped=true"
import script from "./EditLive.vue?vue&type=script&lang=js"
export * from "./EditLive.vue?vue&type=script&lang=js"
import style0 from "./EditLive.vue?vue&type=style&index=0&id=d6bcee90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bcee90",
  null
  
)

export default component.exports